import React, { useRef, useState } from "react";
import { Camera, Image, ChevronDown } from "lucide-react";

const PhotoCaptureButton = ({
  onPhotoSelect,
  disabled = false,
  hasPhoto = false,
  buttonText = "Capture Photo",
  retakeText = "Retake Photo",
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const cameraInputRef = useRef(null);
  const galleryInputRef = useRef(null);

  const handleCapture = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onPhotoSelect(file);
      setShowOptions(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowOptions(!showOptions)}
        disabled={disabled}
        className="flex-1 px-4 py-2 bg-blue-100 text-blue-700 text-sm font-medium rounded-lg hover:bg-blue-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        <Camera className="w-4 h-4" />
        {hasPhoto ? retakeText : buttonText}
        <ChevronDown className="w-3 h-3" />
      </button>

      {/* Dropdown Options */}
      {showOptions && !disabled && (
        <div className="absolute top-full mt-1 right-0 z-10 bg-white border border-gray-300 rounded-lg shadow-lg overflow-hidden">
          {/* Camera Option */}
          <button
            onClick={() => cameraInputRef.current?.click()}
            className="w-full px-4 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors flex items-center gap-2 border-b border-gray-200"
          >
            <Camera className="w-4 h-4 text-gray-600" />
            Take Photo
          </button>

          {/* Gallery Option */}
          <button
            onClick={() => galleryInputRef.current?.click()}
            className="w-full px-4 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors flex items-center gap-2"
          >
            <Image className="w-4 h-4 text-gray-600" />
            Choose from Gallery
          </button>
        </div>
      )}

      {/* Hidden File Inputs */}
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleCapture}
        className="hidden"
      />
      <input
        ref={galleryInputRef}
        type="file"
        accept="image/*"
        onChange={handleCapture}
        className="hidden"
      />
    </div>
  );
};

export default PhotoCaptureButton;
